




































import { defineComponent, PropType } from '@vue/composition-api';
import { dtFormat } from '@/lib/dateHelper';
import type {
  HokkaidoAirportSettings,
} from '@/models/apis/externalReports/hokkaidoAirport/hokkaidoAirportSettings';

export default defineComponent({
  props: {
    userSettings: {
      type: Object as PropType<HokkaidoAirportSettings>,
      required: true,
    },
    isRealtimeMode: {
      type: Boolean,
      default: false,
    },
    carsUpdatedAt: {
      type: Date,
    },
    movingCarsCount: {
      type: Number,
      default: 0,
    },
    stoppedCarsCount: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    return {
      dtFormat,
    };
  },
});
